if (!customElements.get('product-upsell')) {
  customElements.define(
    'product-upsell',
    class ProductUpsell extends HTMLElement {
      constructor() {
        super();
        this.addToCartButton = this.querySelector('[data-upsell-action="add-to-cart"]');
      }

      connectedCallback() {
        if (!this.addToCartButton) return;
        this.addToCartButton.addEventListener('click', (event) => this.addToCart(event));
      }

      async addToCart(event) {
        event.preventDefault();
        const variantID = this.addToCartButton.dataset?.variantId;
        if (!variantID) return;
        try {
          document.dispatchEvent(new CustomEvent('theme:loading:start'));
          this.addToCartButton.disabled = true;
          const url = `${window.Shopify.routes.root}cart/add.js`;
          const data = {
            items: [
              {
                id: variantID,
                quantity: 1,
              },
            ],
          };
          const config = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
            body: JSON.stringify(data),
          };

          const response = await fetch(url, config);
          const result = await response.json();
          document.dispatchEvent(new CustomEvent('theme:loading:end'));

          if (response.ok) {
            this.addToCartButton.disabled = false;
            document.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: variantID,
                  quantity: 1,
                },
              })
            );
          } else {
            console.error(result.message);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  );
}
